import {
  FieldDefinition,
  FieldBuilder,
  MenuCategories,
  MenuSubcategories,
  MENU_CATEGORY_KEY,
  MENU_SUBCATEGORY_KEY,
  MENU_NAME_SUFFIX,
  checkboxFormatter,
} from '@zendra/shared';
import { Formatter } from 'angular-slickgrid';
import { LocationService, PropertyService, PropertyTypeService, SoilUseService } from 'cbd-proxies';
import { OtherUseByConservationType } from '../other-use-by-conservation-type/other-use-by-conservation-type';
import { OtherUsePerRegister } from '../other-use-per-register/other-use-per-register';

FieldBuilder.setNamespace('Planning');

export const nullableFOManagementFormatter: Formatter = (
  row,
  cell,
  value,
  columnDef,
  dataContext,
  grid
) => {
  const foManagementValue = value ?? dataContext?.propertyType?.isFOManagement;

  if (foManagementValue === null || foManagementValue === undefined) {
    return '<span aria-hidden="true">—</span>';
  }

  return checkboxFormatter(row, cell, foManagementValue, columnDef, dataContext, grid);
};

export const OTHERUSE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.OtherUse.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .number('otherUsearea', 'Entity.OtherUse.OtherUsearea')
    .required()
    .decimal(2, 10)
    .build(),
  FieldBuilder
    .foreignKey('propertyId', 'Entity.Property', PropertyService)
    .required()
    .displayFromNested('property.name')
    .sortBy('property.name')
    .build(),
  FieldBuilder
    .foreignKey('propertyTypeId', 'Entity.PropertyType', PropertyTypeService)
    .required()
    .displayFromNested('propertyType.name')
    .sortBy('propertyType.name')
    .build(),
  FieldBuilder
    .checkbox('isFOManagement', 'Entity.PropertyType.IsFOManagement')
    .readOnly()
    .formatter(nullableFOManagementFormatter)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .foreignKey('soilUseId', 'Entity.SoilUse', SoilUseService)
    .required()
    .displayFromNested('soilUse.name')
    .sortBy('soilUse.name')
    .build(),
  FieldBuilder
    .number('otherUseGisArea', 'Entity.OtherUse.OtherUseGisArea')
    .decimal(2, 10)
    .readOnly()
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const OTHERUSE_CONFIG = {
  entityName: 'OtherUse',
  localizationKey: 'Planning::Entity.OtherUse',
  permission: 'PlanningLocation.OtherUses',
  fields: OTHERUSE_FIELDS,
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.TablesPlanning + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'OtherUseByConservationType',
      foreignKeyField: 'otherUseId',
      localizationKey: 'Geographic::Entity.OtherUseByConservationType',
      component: OtherUseByConservationType,
    },
    {
      entityName: 'OtherUsePerRegister',
      foreignKeyField: 'otherUseId',
      localizationKey: 'Geographic::Entity.OtherUsePerRegister',
      component: OtherUsePerRegister,
    },
  ],
};
